module.exports = __webpack_public_path__ + "img/Edgar_L_Rhodes_Center_for_Animal_and_Dairy_Sciences-t-18805-s001.8c63e59f.jpg";